import { ACCOUNT_TIERS } from 'types/billing';

export const FEATURE_BOX_KEYS = ['1', '2', '3', '4'] as const;

export const TIER_SUBTITLE_KEYS = {
  [ACCOUNT_TIERS.free]: 'subtitle-free',
  [ACCOUNT_TIERS.trial]: 'subtitle-free',
  [ACCOUNT_TIERS.paid]: 'subtitle-paid',
} as const;
